module.exports = __webpack_public_path__ + "ionicons.621bd386841f74e0053c.svg";


//////////////////
// WEBPACK FOOTER
// D:/MMC App/MMC/src/bower_components/Ionicons/fonts/ionicons.svg?v=2.0.0
// module id = ../../../../../src/bower_components/Ionicons/fonts/ionicons.svg?v=2.0.0
// module chunks = 2